// @flow
import React, { useEffect, useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import Loading from 'app/common/components/Loader';

import styles from './StatementsListLoader.scss';


/**
 * Загружает следующую порцию заказов, когда компонент становится видимым
 */

type Props = {
  loading?: boolean,
  onVisible?: () => Promise<boolean> | boolean,
  disable?: boolean,
}

const StatementsListLoader = ({ loading, onVisible, disable }: Props) => {
  const [visibility, setVisibility] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // первая загрузка отменяется
    // (первая - на монтирование элемента, потом уже происходит visibility)
    if (!mounted) {
      setMounted(true);
      return;
    }
    // элемент появляется, начинаем грузить
    if (mounted && visibility && onVisible && !disable) {
      onVisible();
    }
  }, [visibility]);

  // когда загрузка завершена, а загрузчик все еще visible, грузим дальше
  useEffect(() => {
    if (!loading && visibility && onVisible && !disable) {
      onVisible();
    }
  }, [loading]);

  return (
    <VisibilitySensor onChange={setVisibility} partialVisibility delayedCall>
      {loading
        ? <Loading className={styles.loading} />
        : <div>&nbsp;</div>}
    </VisibilitySensor>
  );
};

export default StatementsListLoader;
